<script setup lang="ts">
import { vMaska, MaskaDetail } from 'maska';
import { useForm, Link, router, Head } from '@inertiajs/vue3';
import { onMounted, reactive, ref } from 'vue';

const props = defineProps({
    enrollments: {type: Array, required: true},
    pagination: {type: Object, required: false},
    flash: {type: Object, required: true}
})

const studentForm = useForm({
    name: '',
    cpf: '',
    search: true
})

const cpf_mask = reactive({}) as MaskaDetail;

const selected_enrollment = ref({})

let modal = null;

function selectEnrollment(enrollment) {
    selected_enrollment.value = enrollment;
    modal?.show();
}

function submit() {
    router.post(selected_enrollment.value.send_certificate_url)
    modal?.hide();
}

onMounted(() => {
    //@ts-ignore
    modal = new bootstrap.Modal('#confirmationModal');
})
</script>

<template>
    <Head title="Enviar Certificado" />

    <div class="alert alert-success" v-if="props.flash.success">
        {{props.flash.success}}
    </div>

    <div class="alert alert-danger" v-if="props.flash.error">
        {{props.flash.error}}
    </div>

    <div class="col-12">
        <div class="card card-xl-stretch mb-xl-8">
            <div class="card-header">
                <h3 class="card-title fw-bolder text-dark">
                    <span class="fa-solid fa-award me-3"></span>
                    <span>Enviar Certificado</span>
                </h3>
            </div>

            <div class="card-body">
                <form @submit.prevent="studentForm.get('/dashboard/master/enrollment/send-certificate')">
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <div class="mb-3">
                                <label for="student-name" class="form-label">Nome do Aluno</label>
                                <input
                                    v-model="studentForm.name"
                                    type="text"
                                    class="form-control"
                                    id="student-name" >
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="mb-3">
                                <label for="student-cpf" class="form-label">CPF do Aluno</label>
                                <input
                                    v-maska="cpf_mask"
                                    v-model="studentForm.cpf"
                                    data-maska="###.###.###-##"
                                    type="text"
                                    class="form-control"
                                    id="student-cpf">
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-5">
                        <button type="submit" class="btn btn-primary">
                            Buscar Aluno
                        </button>
                    </div>
                </form>

                <div v-if="props.enrollments?.length > 0" class="row table-responsive">
                    <div class="container">
                        <h4 class="mt-10 mb-5">Resultado:</h4>

                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th scope="col">NOME</th>
                                <th scope="col">CPF</th>
                                <th scope="col">CFC</th>
                                <th scope="col">CURSO</th>
                                <th scope="col">AÇÃO</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-for="enrollment in props.enrollments" :key="enrollment.id">
                                    <th scope="row">{{ enrollment.name }}</th>
                                    <td>{{ enrollment.cpf }}</td>
                                    <td>{{ enrollment.subtenant_course.subtenant.apelido }}</td>
                                    <td>{{enrollment.subtenant_course.course.description}}</td>
                                    <td>
                                        <button type="button" class="btn btn-primary btn-sm" @click="selectEnrollment(enrollment)">
                                            Enviar Certificado Detran
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <nav>
                            <ul class="pagination">
                                <li class="page-item" v-if="props.pagination?.prev_page_url">
                                    <Link
                                        :href="props.pagination?.prev_page_url"
                                        class="page-link">
                                        Anterior
                                    </Link>
                                </li>
                                <li class="page-item">
                                    <a class="page-link" href="#">{{ props.pagination?.current_page }}</a>
                                </li>
                                <li class="page-item" v-if="props.pagination?.next_page_url">
                                    <Link
                                        class="page-link"
                                        :href="props.pagination?.next_page_url">
                                        Próxima
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div
                    class="mt-10 text-danger"
                    v-if="props.enrollments?.length === 0 && props.pagination">
                    Nenhum aluno encontrado
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="confirmationModal" tabindex="-1" aria-labelledby="confirmationModal">
        <div class="modal-dialog">
            <form @submit.prevent="submit">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel">Confirmação</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        Deseja enviar o certificado para o Detran do aluno: {{selected_enrollment.name }} ?
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                        <button type="submit" class="btn btn-primary">Enviar Certificado</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
